import { motion } from 'framer-motion';

import './about.css';
import logo from '../../assets/logo.png';
import ckadIcon from '../../assets/certifications/ckad.png';
import mlIcon from '../../assets/certifications/ml.png';
import aiIcon from '../../assets/certifications/ai.png';
import gcpProIcon from '../../assets/certifications/gcp-pro.png';
import saaIcon from '../../assets/certifications/saa.png';
import sapIcon from '../../assets/certifications/sap.png';
import secIcon from '../../assets/certifications/sec.png';

const About = ({ pageRef }) => {

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section ref={pageRef} className="about-section">
      <motion.div
        className="about-container"
        variants={containerVariants}
        initial="visible"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        <motion.div className="about-header" variants={itemVariants} initial="visible">
          <h2 className="about-title">Global Team, Local Expertise</h2>
          <p className="about-description">
            We have engineers in Poland, Portugal and the US with a wide range of skills and experience,
            who are ready to help you with your project. Our team holds certifications in Kubernetes,
            Machine Learning, and Cloud platforms including Google Cloud Platform (GCP) and Amazon Web Services (AWS).
          </p>
        </motion.div>

        <motion.div className="certifications-section" variants={itemVariants} initial="visible">
          <h3 className="certifications-title">Team Certifications</h3>
          <div className="certifications-grid">
            <div className="certification-badge">
              <span className="certification-text">Kubernetes Certified</span>
              <div className="certification-icons">
                <img src={ckadIcon} alt="CKAD" className="certification-icon" />
              </div>
            </div>
            <div className="certification-badge">
              <span className="certification-text">Cloud ML / AI Certified</span>
              <div className="certification-icons">
                <img src={mlIcon} alt="ML" className="certification-icon" />
                <img src={aiIcon} alt="AI" className="certification-icon" />
              </div>
            </div>
            <div className="certification-badge">
              <span className="certification-text">Google Cloud Certified</span>
              <div className="certification-icons">
                <img src={gcpProIcon} alt="GCP Professional" className="certification-icon" />
              </div>
            </div>
            <div className="certification-badge">
              <span className="certification-text">AWS Certified</span>
              <div className="certification-icons">
                <img src={saaIcon} alt="AWS SAA" className="certification-icon" />
                <img src={sapIcon} alt="AWS SAP" className="certification-icon" />
                <img src={secIcon} alt="AWS Security" className="certification-icon" />
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div className="team-section" variants={itemVariants} initial="visible">
          <div className="team-stats">
            <div className="stat-item">
              <h3>15+</h3>
              <p>Years Experience</p>
            </div>
            <div className="stat-item">
              <h3>20+</h3>
              <p>Projects Delivered</p>
            </div>
            <div className="stat-item">
              <h3>3</h3>
              <p>Countries</p>
            </div>
          </div>
        </motion.div>

        <motion.footer className="footer" variants={itemVariants} initial="visible">
          <div className="footer-content">
            <div className="footer-left">
              <img src={logo} alt="RockSoftware" className="footer-logo" />
              <div className="footer-info">
                <p className="footer-location">Seattle, Washington</p>
                <p className="footer-email">
                  <a href="mailto:info@rocksoftware.io">info@rocksoftware.io</a>
                </p>
              </div>
            </div>
            <div className="footer-right">
              <p className="copyright">© 2020-2025 RockSoftware LLC. All rights reserved.</p>
            </div>
          </div>
        </motion.footer>
      </motion.div>
    </section>
  )
}

export default About;
